module.exports = {
      id: "ee961433ea03b07b3aadc3e9f309b85abathroomEquipment-luxury-bathtub.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#ee961433ea03b07b3aadc3e9f309b85abathroomEquipment-luxury-bathtub.svg",
      toString: function () {
        return this.url;
      }
    }